var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30023 2.67828e-05C1.43356 2.67828e-05 1.56023 0.0520266 1.65356 0.146693L4.9869 3.48003C5.12556 3.61736 5.20223 3.80469 5.20023 4.00003C5.20061 4.09647 5.18197 4.19205 5.14536 4.28128C5.10875 4.37051 5.0549 4.45164 4.9869 4.52003L1.65356 7.85336C1.55981 7.94699 1.43273 7.99959 1.30023 7.99959C1.16773 7.99959 1.04065 7.94699 0.946898 7.85336C0.899727 7.8074 0.862236 7.75245 0.836638 7.69177C0.81104 7.63108 0.797852 7.56589 0.797852 7.50003C0.797852 7.43417 0.81104 7.36897 0.836638 7.30828C0.862236 7.2476 0.899727 7.19266 0.946898 7.14669L4.09356 4.00003L0.946898 0.85336C0.899727 0.807396 0.862236 0.752452 0.836638 0.691768C0.81104 0.631084 0.797852 0.565889 0.797852 0.500027C0.797852 0.434165 0.81104 0.368969 0.836638 0.308285C0.862236 0.247601 0.899727 0.192657 0.946898 0.146693C0.992831 0.0996454 1.04782 0.0623933 1.10855 0.0371854C1.16928 0.0119776 1.23448 -0.000662999 1.30023 2.67828e-05Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNav);
export default __webpack_public_path__ + "static/media/ArrowNav.69d84a9d7837f1d052b5c4d74aa69d19.svg";
export { ForwardRef as ReactComponent };